export default __webpack_public_path__ + "static/media/sdk-documentation-screen.71437b66.svg";